import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Button, Modal, Input, notification } from "antd";
import moment from "moment";
import TobNavBar from "../../DashBaord/Top_navbar";
import { changeStatus } from "../../../controllers/V1/userRequest/userRequestController";
import { usePermissions } from "../../../controllers/PermissionContext";
import { ASSETS_BASE_URL } from "../../../config/constants";
import { formatProjectDate } from "../../../controllers/common";

const { TextArea } = Input;

export default function UserRequestView() {
  const location = useLocation();
  const navigate = useNavigate();
  const item = location.state;
  const PERMISSION = usePermissions("userRequest");

  const [actionModal, setActionModal] = useState({ open: false, action: "", title: "" });
  const [remarks, setRemarks] = useState("");
  const [isSubmitting, setIsSubmitting] = useState("");

  const openModal = (action, title) => {
    setRemarks("");
    setActionModal({ open: true, action, title });
  };

  const handleAction = async () => {
    if (!item?._id) return;
    setIsSubmitting(actionModal.action);
    const res = await changeStatus({
      id: item._id,
      action: actionModal.action,
      ...(actionModal.action.includes("bdm") ? { bdm_remarks: remarks } : { deployment_remarks: remarks }),
      remarks,
    });
    setIsSubmitting("");
    if (res.status) {
      notification.success({ message: "Status updated successfully" });
      setActionModal({ open: false, action: "", title: "" });
      navigate("/users/request-list");
    } else {
      notification.error({ message: res.message || "Failed to update status" });
    }
  };

  const statusDot = (status) => {
    const colors = { Pending: "#f5a623", Approved: "rgb(17 174 87)", Completed: "rgb(17 174 87)", Rejected: "#ae1151" };
    return (
      <span style={{ display: "inline-flex", alignItems: "center", gap: 6 }}>
        <span style={{ width: 10, height: 10, borderRadius: "50%", backgroundColor: colors[status] || "#888", display: "inline-block" }} />
        <strong>{status}</strong>
      </span>
    );
  };

  const docLink = (path, label) => {
    if (!path) return <span className="text-muted">Not uploaded</span>;
    return <a href={`${ASSETS_BASE_URL}${path}`} target="_blank" rel="noreferrer">{label}</a>;
  };

  if (!item) {
    return (
      <div className="container-fluid">
        <TobNavBar title="User Request View" />
        <p>No data. Go back to list.</p>
      </div>
    );
  }

  const canBdmAction      = (PERMISSION.fullAccess === 'Y' || PERMISSION.changeStatus === 'Y') && item.bdm_status === 'Pending';
  const canDeployAction   = (PERMISSION.fullAccess === 'Y' || PERMISSION.changeStatus === 'Y') && item.bdm_status === 'Approved' && item.deployment_status === 'Pending';

  return (
    <>
      <div className="container-fluid">
        <TobNavBar title="User Request View" />

        <div className="card shadow mb-4">
          <div className="card-header d-flex justify-content-between align-items-center">
            <h5 className="mb-0">Request Details</h5>
            <Button onClick={() => navigate("/users/request-list")}>Back to List</Button>
          </div>
          <div className="card-body">
            <div className="row">
              <div className="col-md-6 mb-3">
                <label className="all_section_for_label_main_class">Full Name</label>
                <p className="form-control-plaintext">{item.first_name} {item.last_name}</p>
              </div>
              <div className="col-md-6 mb-3">
                <label className="all_section_for_label_main_class">Mobile</label>
                <p className="form-control-plaintext">{item.country_code}{item.mobile}</p>
              </div>
              <div className="col-md-6 mb-3">
                <label className="all_section_for_label_main_class">Email</label>
                <p className="form-control-plaintext">{item.email || "—"}</p>
              </div>
              <div className="col-md-6 mb-3">
                <label className="all_section_for_label_main_class">Store Name</label>
                <p className="form-control-plaintext">{item.store_name || "—"}</p>
              </div>
              <div className="col-md-6 mb-3">
                <label className="all_section_for_label_main_class">Area</label>
                <p className="form-control-plaintext">{item.area || "—"}</p>
              </div>
              <div className="col-md-6 mb-3">
                <label className="all_section_for_label_main_class">Address</label>
                <p className="form-control-plaintext">{item.address || "—"}</p>
              </div>
              <div className="col-md-6 mb-3">
                <label className="all_section_for_label_main_class">Trade License No.</label>
                <p className="form-control-plaintext">{item.trade_license_no || "—"}</p>
              </div>
              <div className="col-md-6 mb-3">
                <label className="all_section_for_label_main_class">POS Number</label>
                <p className="form-control-plaintext">{item.pos_number || "—"}</p>
              </div>
              {item.bind_person_id && (
                <div className="col-md-6 mb-3">
                  <label className="all_section_for_label_main_class">Bound Person</label>
                  <p className="form-control-plaintext">
                    {item.bind_person_id?.users_name} {item.bind_person_id?.last_name} ({item.bind_person_id?.users_mobile})
                  </p>
                </div>
              )}
              <div className="col-md-6 mb-3">
                <label className="all_section_for_label_main_class">Created Date</label>
                <p className="form-control-plaintext">{item.createdAt ? moment(formatProjectDate(item.createdAt)).format("DD-MM-YYYY hh:mm A") : "—"}</p>
              </div>
            </div>

            {/* Documents */}
            <h6 className="mt-3 mb-2">Documents</h6>
            <div className="row">
              <div className="col-md-3 mb-2"><label>Trade License:</label><br />{docLink(item.tradeLicense, "View")}</div>
              <div className="col-md-3 mb-2"><label>ID Front:</label><br />{docLink(item.id_proof_front, "View")}</div>
              <div className="col-md-3 mb-2"><label>ID Back:</label><br />{docLink(item.id_proof_back, "View")}</div>
              <div className="col-md-3 mb-2"><label>Signature:</label><br />{docLink(item.signature, "View")}</div>
              {item.pos_image && <div className="col-md-3 mb-2"><label>POS Image:</label><br />{docLink(item.pos_image, "View")}</div>}
            </div>

            {/* Status */}
            <h6 className="mt-3 mb-2">Status</h6>
            <div className="row">
              <div className="col-md-4 mb-2">
                <label>BDM Status:</label><br />{statusDot(item.bdm_status)}
                {item.bdm_remarks && <p className="text-muted small mt-1">{item.bdm_remarks}</p>}
              </div>
              <div className="col-md-4 mb-2">
                <label>Deployment Status:</label><br />{statusDot(item.deployment_status)}
                {item.deployment_remarks && <p className="text-muted small mt-1">{item.deployment_remarks}</p>}
              </div>
              <div className="col-md-4 mb-2">
                <label>Overall Status:</label><br />{statusDot(item.status)}
                {item.remarks && <p className="text-muted small mt-1">{item.remarks}</p>}
              </div>
            </div>

            {/* Actions */}
            <div className="mt-4 d-flex gap-2 flex-wrap">
              {canBdmAction && (
                <>
                  <Button type="primary" style={{ backgroundColor: "rgb(17 174 87)" }} onClick={() => openModal("bdm_approve", "BDM Approve")}>BDM Approve</Button>
                  <Button type="primary" danger onClick={() => openModal("bdm_reject", "BDM Reject")}>BDM Reject</Button>
                </>
              )}
              {canDeployAction && (
                <>
                  <Button type="primary" style={{ backgroundColor: "#1677ff" }} onClick={() => openModal("deployment_approve", "Deployment Approve")}>Deployment Approve</Button>
                  <Button type="primary" danger onClick={() => openModal("deployment_reject", "Deployment Reject")}>Deployment Reject</Button>
                </>
              )}
            </div>
          </div>
        </div>
      </div>

      <Modal
        title={actionModal.title}
        open={actionModal.open}
        onCancel={() => setActionModal({ open: false, action: "", title: "" })}
        footer={[
          <Button key="cancel" onClick={() => setActionModal({ open: false, action: "", title: "" })}>Cancel</Button>,
          <Button key="submit" type="primary" loading={!!isSubmitting} onClick={handleAction}
            danger={actionModal.action?.includes("reject")}>
            Confirm
          </Button>,
        ]}
      >
        <div className="mb-3">
          <label>Remarks:</label>
          <TextArea rows={3} value={remarks} onChange={(e) => setRemarks(e.target.value)} placeholder="Enter remarks..." />
        </div>
      </Modal>
    </>
  );
}
